import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'

//Plugins
import './plugins'

//App component
import App from './App.vue'

//Service Worker
import './registerServiceWorker'

//Router
import router from './router'

//Store Vuex
import store from './store'

Vue.config.productionTip = false

// Init App
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
